import sidebar from './sidebar.vue'
export default sidebar
